import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {YearService} from '../../../services/year.service';

@Component({
  selector: 'app-year-add-edit',
  templateUrl: './year-add-edit.component.html',
  styleUrls: ['./year-add-edit.component.scss']
})
export class YearAddEditComponent implements OnInit{

  yearForm: FormGroup;
  lastYearList: any[] = [];
  lastYearListSelect: number | undefined;
  saving = false;

  public data: any;

  isSubmitted = false;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private yearService: YearService,
              private translate: TranslateService,
              private toast: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.yearForm = this.fb.group({
      year: ['', [Validators.required]],
      startAt: ['', [Validators.required]],
      endAt: ['', [Validators.required]],
      // lastYear: ['', [Validators.required]],
      // objective: '',
    });

  }

  ngOnInit(): void {
    this.yearForm.patchValue(this.data);
    this.getLastYearList();

    if (!this.data){
      this.getLastYearList();
    }
    else {
      this.lastYearListSelect = this.data.lastYear['@id'];
    }
  }

  get fc(): any {
    return this.yearForm.controls;
  }

  onFormSubmit(): any {
    this.isSubmitted = true;
    if (this.yearForm.valid){
      this.saving = true;
      if (this.data){
        this.yearService.put(this.data.id, this.yearForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('year') + ' ' + this.translate.instant('editeed') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {

            const errors: any[] = err.violations;

            errors.forEach((v) =>
            {
              if (v.propertyPath === 'year'){
                this.yearForm.get('year')?.setErrors({serverError: v.message});
              }

              this.saving = false;

            });
          }
        });
      }
      else {
        this.yearService.post(this.yearForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('year') + ' ' + this.translate.instant('createed') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {

            console.log(err);
            if (err['hydra:title'] && err['hydra:description']){
              this.toast.error(err['hydra:description'], err['hydra:title']);
            }
            else {
              const errors: any[] = err.violations;

              errors.forEach((v) =>
              {
                if (v.propertyPath === 'year'){
                  this.yearForm.get('year')?.setErrors({serverError: v.message});
                }

              });
            }

            this.saving = false;
          }
        });


      }

    }
  }

  getLastYearList(): void{
    this.yearService.getCollection().subscribe((data: any) => {
          this.lastYearList = data['hydra:member'];
          this.lastYearList = this.lastYearList.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }


}
